export default __webpack_public_path__ + "static/media/RBLogo.95ac3086.svg";